import styled from 'styled-components';
import { getSpacingToken, getTextTokenPreset, getToken } from '@optimus-web/common';
import { getBackgroundColor, getBorderColor, getColor } from './getTagStyles';
import { TagVariant } from './types';

export const MAX_TAG_WIDTH = 200;

export const TagContainer = styled.div<{ variant?: TagVariant; outline?: boolean }>`
    background-color: ${(props) => (props.outline ? getToken('backgroundStaticFlat') : getBackgroundColor(props))};
    color: ${(props) => getColor(props)};
    border: ${getToken('borderWidth150')}px solid ${(props) => (props.outline ? getBorderColor(props) : 'transparent')};
    height: calc(${getToken('sizing300')}px - (${getToken('borderWidth150')}px * 2));
    display: inline-flex;
    gap: ${getSpacingToken('50')}px;
    padding: 0 ${getSpacingToken('100')}px;
    align-items: center;
    border-radius: ${getToken('borderRadius50')}px;
`;

export const TagText = styled.span<{ variant?: TagVariant; outline?: boolean }>`
    max-width: ${MAX_TAG_WIDTH}px;
    ${getTextTokenPreset('bodyMedium')};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
